import { Controller } from "@hotwired/stimulus"

// Lets an admin paste a JSON blob (drafted by hand with an LLM elsewhere)
// and populate the SEO content fields in one shot instead of retyping them.
export default class extends Controller {
  static targets = ["prompt", "copyStatus", "input", "context", "summary", "client", "agency", "tags", "status"]

  async copyPrompt(event) {
    event.preventDefault()

    try {
      await navigator.clipboard.writeText(this.promptTarget.value)
      this.copyStatusTarget.textContent = "Copied!"
    } catch (e) {
      this.promptTarget.select()
      this.copyStatusTarget.textContent = "Couldn't copy automatically — text is selected, press Cmd/Ctrl+C."
    }

    setTimeout(() => { this.copyStatusTarget.textContent = "" }, 3000)
  }

  fill(event) {
    event.preventDefault()

    let data
    try {
      data = JSON.parse(this.inputTarget.value)
    } catch (e) {
      this.showStatus("That's not valid JSON — check for a stray comma or missing quote.", true)
      return
    }

    this.setValue(this.contextTarget, data.context_description)
    this.setValue(this.summaryTarget, data.summary_description)
    this.setValue(this.clientTarget, data.client_description)
    this.setValue(this.agencyTarget, data.agency_description)

    if (Array.isArray(data.tags)) {
      this.setValue(this.tagsTarget, data.tags.join(", "))
    } else if (typeof data.tags === "string") {
      this.setValue(this.tagsTarget, data.tags)
    }

    this.showStatus("Fields populated below — review before saving.", false)
  }

  setValue(target, value) {
    if (typeof value !== "string" || !value.trim()) return
    target.value = value
    target.dispatchEvent(new Event("input", { bubbles: true }))
  }

  showStatus(message, isError) {
    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle("text-[#B3423A]", isError)
    this.statusTarget.classList.toggle("text-graphite", !isError)
  }
}
